import { useMemo } from 'react'
import { Chart as ChartJS, Tooltip, Legend, BarElement, ChartDataset, ChartData } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { Typography } from '@mui/material'

ChartJS.register(BarElement, Tooltip, Legend)

// TODO: create a generic bar chart
export type CountByStringComponentProps = {
  chartData?: Pick<ChartData<'bar', number[]>, 'datasets' | 'labels'>
  title: string
}

function CountByStringComponent(props: CountByStringComponentProps) {
  const { chartData, title } = props

  const options = {
    responsive: true,
    label: false,
  }

  const extendedChartData = useMemo(() => {
    return {
      labels: chartData?.labels ?? [],
      datasets:
        chartData?.datasets.map((dataset) => ({
          label: title,
          data: dataset?.data ?? [],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)',
          ],
        })) ?? [],
    }
  }, [chartData, title])

  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Bar data={extendedChartData} options={options} />
    </>
  )
}

export default CountByStringComponent
